import client from '../../client';

const PATH = '/predictions/classifications'


/**
 * Get the classifications objects from the backend. For more information please read
 * the docs of the correspondent middleware in the back.
 */
function get() {
  return client.get(PATH).then(({ data }) => data.classifications);
}


/**
 * Get the categories by sellers ids.
 * For more information please read the middleware documentation in the backend.
 * @param {Object} params for the query
 */
function getCategoriesBySellers({ sellersIds }) {
  return client.get(`${PATH}/categories`, { params: { sellersIds } }).then(({ data }) => data)
}


/**
 * Get the items with predictions for a given classification.
 * To know more about this endpoint please visit the middleware in the api.
 * @param {Object} params
 */
function getItems(params) {
  return client.get(`${PATH}/${params.classificationId}/items`, { params }).then(({ data }) => data)
}


/**
 * Get the sellers that contains items with predictions for the given classification id.
 * For more information please read the docs of its middleware in the api.
 * @param {Object} payload
 */
function getSellersWithPredictions({ classificationId, validated }) {
  return client.get(`${PATH}/${classificationId}/sellers`, { params: { validated } }).then(({ data }) => data)
}


/**
 * Save the correction of the predictions.
 * For more info please visit the middleware that handle this job in the api.
 * @param {Object} payload
 */
function save({ classificationId, fullCorrect, fullIncorrect, sellerId, categoryUrl, items, validated }) {
  return client.put(`${PATH}/${classificationId}/items`, {
    fullCorrect,
    fullIncorrect,
    sellerId,
    categoryUrl,
    items,
    validated
  })
}

function updateQuantity({ classificationId, items, quantity }) {
  return client.post(`${PATH}/${classificationId}/items`, {
    items,
    quantity
  })
}


export default {
  get,
  getCategoriesBySellers,
  getItems,
  getSellersWithPredictions,
  save,
  updateQuantity
}
